import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/esm/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import React from "react";
import PropTypes from "prop-types";
import scrollIntoView from "scroll-into-view-if-needed";

var listItemContainer = function listItemContainer(Component) {
  var WrappedListItem =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(WrappedListItem, _React$Component);

    function WrappedListItem() {
      var _getPrototypeOf2, _context;

      var _this;

      _classCallCheck(this, WrappedListItem);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WrappedListItem)).call.apply(_getPrototypeOf2, _concatInstanceProperty(_context = [this]).call(_context, args)));

      _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (e) {
        var _this$props = _this.props,
            suggestion = _this$props.suggestion,
            onClick = _this$props.onClick;

        _this.context.onSuggestionClick(e, suggestion);

        if (onClick) onClick(e, suggestion);
      });

      return _this;
    }

    _createClass(WrappedListItem, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(_ref, _ref2) {
        var position = _ref.position;
        var activeIndex = _ref2.activeIndex;

        if (position == null) {
          return;
        }

        if (activeIndex === position) {
          // Ensures that if the menu items exceed the bounds of the menu, the
          // menu will scroll up or down as the user hits the arrow keys.
          scrollIntoView(this.li, {
            scrollMode: 'if-needed',
            behavior: 'auto'
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var activeIndex = this.context.activeIndex;

        var _this$props2 = this.props,
            position = _this$props2.position,
            suggestion = _this$props2.suggestion,
            rest = _objectWithoutProperties(_this$props2, ["position", "suggestion"]);

        return React.createElement(Component, _extends({}, rest, {
          liRef: function liRef(li) {
            _this2.li = li;
          },
          active: activeIndex === position,
          onClick: this.handleOnClick
        }));
      }
    }]);

    return WrappedListItem;
  }(React.Component);

  process.env.NODE_ENV !== "production" ? WrappedListItem.propTypes = {
    suggestion: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onClick: PropTypes.func,
    position: PropTypes.number
  } : void 0;
  WrappedListItem.contextTypes = {
    activeIndex: PropTypes.number.isRequired,
    onSuggestionClick: PropTypes.func.isRequired
  };
  return WrappedListItem;
};

export default listItemContainer;